import React, { PropTypes } from 'react';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { bibShape } from '@bibliocommons/bc-prop-types';

import BaseCancelHoldWorkflowView from './BaseCancelHoldWorkflowView';

export class SingleCancelHoldWorkflowView extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleCancelHold');
  }

  handleCancelHold({ shelfState }) {
    const { accountId, holdId, bib, messagingId, workflowId } = this.props;
    this.props.cancelHold({
      accountId,
      metadataIds: [bib.get('metadataId')],
      holdIds: [holdId],
      shelfState,
      messagingId,
      workflowId
    });
  }

  render() {
    const { handleClose, accountId, holdId, isLoading, bib, shelves, messagingId } = this.props;
    const showShelfPrompt = !shelves.get(bib.get('metadataId'));

    return (
      <BaseCancelHoldWorkflowView
        testId={`cancel-holds-overlay-${bib.get('id')}`}
        handleClose={handleClose}
        handleCancelHold={this.handleCancelHold}
        accountId={accountId}
        holdIds={Immutable.List.of(holdId)}
        isLoading={isLoading}
        showShelfPrompt={showShelfPrompt}
        bibs={Immutable.List.of(bib)}
        messagingId={messagingId} />
    );
  }
}

SingleCancelHoldWorkflowView.propTypes = {
  handleClose: PropTypes.func.isRequired,
  cancelHold: PropTypes.func.isRequired,
  accountId: PropTypes.number.isRequired,
  holdId: PropTypes.string,
  isLoading: PropTypes.bool,
  bib: bibShape.isRequired,
  shelves: ImmutablePropTypes.map.isRequired,
  messagingId: PropTypes.string,
  workflowId: PropTypes.string
};

export default SingleCancelHoldWorkflowView;



// WEBPACK FOOTER //
// ./app/components/shared/ItemTransactions/components/cancel-hold-workflow-view/components/SingleCancelHoldWorkflowView.jsx